import { DateFormat } from '@gonfalon/format/constants';
import { formatInTimeZone } from 'date-fns-tz';

import { Granularity } from '../../../types';

const MMM_D_YYYY_DOT_HH_MM_Z = "MMM d, yyyy '·' HH:mm z";

export function formatUsageTooltipDate(
  timestamp: number,
  granularity: Granularity,
  { separateTime = false }: { separateTime?: boolean } = {},
): string {
  const date = new Date(timestamp);
  const dateFormat =
    granularity === Granularity.HOURLY || date.getUTCHours() !== 0
      ? separateTime
        ? MMM_D_YYYY_DOT_HH_MM_Z
        : DateFormat.MMM_D_YYYY_HH_MM_Z
      : granularity === Granularity.MONTHLY
        ? DateFormat.MMM_YYYY_Z
        : DateFormat.MMM_D_YYYY_Z;

  return formatInTimeZone(date, 'UTC', dateFormat);
}
